import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import {
  NgbActiveModal,
  NgbDropdownModule,
  NgbModalModule,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { ApiError } from 'src/app/core/providers/error-handling/error.models';
import { AuthenticationService } from 'src/app/core/providers/auth/auth.service';
import { LoginApiResponse } from 'src/app/core/providers/auth/auth.models';
import { Subscription } from 'rxjs';
import { AppContextService } from 'src/app/core/providers/context/AppContextService ';
import { ToastService } from 'src/app/core/providers/toast/toast.service';
import { ModalFormComponent } from 'src/app/shared/modal-form/modal-form.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { HttpErrorResponse } from '@angular/common/http';
import { User } from 'src/app/core/providers/user/users.models';
import { SwitchUserModalComponent } from '../switch-user-modal/switch-user-modal.component';

@Component({
  selector: 'app-login-modal.component',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModalModule,
    NgbDropdownModule,
    SharedModule,
    ModalFormComponent,
  ],
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
})
export class LoginModalComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  isSaving = false;
  isEditMode = true;
  submitted = false;
  authForm: FormGroup;
  messageList: Array<string> = [];
  trans: any = {
    'Bad credentials': "Le couple identifiant / mot de passe n'est pas reconnu",
    'Invalid credentials.':
      "Le couple identifiant / mot de passe n'est pas reconnu",
  };
  context: any;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private appContextService: AppContextService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private toastService: ToastService,
    private authenticationService: AuthenticationService<
      LoginApiResponse | ApiError
    >
  ) {
    this.authForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,7}$'),
        ],
      ],
      password: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    window.scroll(0, 0);
    this.appContextService.context$.subscribe((context) => {
      this.context = context;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get f() {
    return this.authForm.controls;
  }

  submitForm() {
    this.isSaving = true;
    this.submitted = true;
    this.messageList = [];

    if (this.authForm.invalid) {
      this.isSaving = false;
      return;
    }

    const credentials = this.authForm.value;
    credentials.email = credentials.email;

    this.subscription.add(
      this.authenticationService.login(credentials).subscribe({
        next: (response: any) => {
          this.fetchCurrentUserInfo();
        },
        error: (error: HttpErrorResponse) => {
          this.isSaving = false;
        },
      })
    );
  }

  fetchCurrentUserInfo() {
    this.subscription.add(
      this.authenticationService.currentUserInfo().subscribe({
        next: (response: User | ApiError) => {
          if (this.authenticationService.isUser(response)) {
            if (response.roles && response.roles.includes('ROLE_SUPER_ADMIN')) {
              this.activeModal.close();
              this.showSwitchUserModal();
            } else {
              this.toastService.show({
                message: 'Vous avez été reconnecté avec succès.',
                classname: 'bg-success text-light',
                delay: 2500,
              });
              this.activeModal.close();
            }
          } else {
            this.isSaving = false;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.isSaving = false;
        },
      })
    );
  }

  translate(message: any) {
    if (this.trans.hasOwnProperty(message.message)) {
      message.message = this.trans[message.message];
      return message;
    }
    return message;
  }

  forgotPassword() {
    this.activeModal.close();
    this.router.navigate(['/account/recoverpw']);
  }

  close(error: any) {
    this.messageList.splice(this.messageList.indexOf(error), 1);
  }

  dismiss() {}

  private showSwitchUserModal() {
    this.modalService.open(SwitchUserModalComponent, {
      backdrop: 'static',
      keyboard: false,
      size: 'xl',
    });
  }
}
